import { useMemo } from 'react';

import { Company, CompanyScope, OrganizationScope } from '../graphql';
import { useCurrentUser } from './useCurrentUser';
import { useUserFromAuth } from './useUserFromAuth';

export const useCurrentUserScopeForCompany = (
  company: Pick<Company, 'id' | 'isPiiRedacted'> | null,
): {
  isNonFinancial: boolean;
  isPiiRedacted: boolean;
  limitAccessToFinancialData: boolean;
} => {
  const { isSuperUserMode } = useUserFromAuth();
  const { user } = useCurrentUser();

  const companyScope = useMemo(
    () => user?.companyScopes.find((s) => s.companyId === company?.id),
    [company?.id, user?.companyScopes],
  );
  const isOrgAdmin = user?.organizationScope === OrganizationScope.OrganizationAdmin;
  const isNonFinancial = companyScope?.scope === CompanyScope.NonFinancial;

  return {
    isNonFinancial,
    isPiiRedacted: isSuperUserMode || isNonFinancial ? false : (company?.isPiiRedacted ?? true),
    // note: the only user who should be missing a company scope is a super user or an org admin
    limitAccessToFinancialData: isSuperUserMode || isOrgAdmin ? false : !companyScope || isNonFinancial,
  };
};
